import { type CodeSystemUrl, codeSystemUrl } from "./index";
export const REGISTRATION_REVIEW_INPUT_SYSTEM = codeSystemUrl("registration-review-input");
export const CASE_ACQUISITION_SYSTEM = codeSystemUrl("case-acquisition");

/** Every `Coding.system` for a code this codebase defines itself. ADR-0022. */

export const AGGREGATE_WRITE_GUARD_SYSTEM = codeSystemUrl("aggregate-write-guard");
export const ACTIVITY_DEFINITION_CATALOG_SYSTEM = codeSystemUrl("activity-definition-catalog");
export const AI_DEVICE_TYPE_SYSTEM = codeSystemUrl("device-type");
/** `AuditEvent.subtype` for the things this codebase audits itself. */
export const AUDIT_EVENT_SUBTYPE_SYSTEM = codeSystemUrl("audit-event-subtype");
export const CLINICAL_IMPRESSION_TYPE_SYSTEM = codeSystemUrl("clinical-impression-type");
/**
 * The discriminator that keeps a colleague call apart from the OutboundMessage
 * outbox and from any chat, all three of which are Communications. A call has
 * no subject and no patient; the category is the only thing that says which of
 * the three aggregates a row belongs to.
 */
export const COLLEAGUE_CALL_CATEGORY_SYSTEM = codeSystemUrl("colleague-call");
export const CONSULTATION_TYPE_SYSTEM = codeSystemUrl("consultation");
export const COUNTER_CODE_SYSTEM = codeSystemUrl("counter-type");
export const CURATION_SESSION_SYSTEM = codeSystemUrl("curation-session");
export const HS_PROTOCOL_TYPE_SYSTEM = codeSystemUrl("protocol");
export const LOCK_CODE_SYSTEM = codeSystemUrl("lock-type");
export const MESSAGE_CHANNEL_SYSTEM = codeSystemUrl("message-channel");
export const MINDFORGE_OBS_SYSTEM = codeSystemUrl("observation");
export const NOTIFICATION_CATEGORY_SYSTEM = codeSystemUrl("notification-type");
export const ORDER_KIND_SYSTEM = codeSystemUrl("order-set-order-kind");
export const ORDER_SET_KIND_SYSTEM = codeSystemUrl("order-set-kind");
export const OUTBOUND_MESSAGE_PURPOSE_SYSTEM = codeSystemUrl("outbound-message-purpose");
export const PLAN_DEFINITION_KIND_URL = codeSystemUrl("plan-definition-kind");
export const PREFS_BASIC_SYSTEM = codeSystemUrl("notify-prefs");
export const PROCEDURE_CODE_SYSTEM = codeSystemUrl("procedure-code");
export const RETRACTION_SYSTEM = codeSystemUrl("task-retraction");
export const SCHEDULE_SERVICE_TYPE_SYSTEM = codeSystemUrl("schedule-service-type");
export const SCHEDULING_PROFILE_TYPE_SYSTEM = codeSystemUrl("scheduling-profile");
export const SENTINEL_SERVICE_TYPE_SYSTEM = codeSystemUrl("schedule-service-type");
export const SOURCE_IDENTITY_TYPE = codeSystemUrl("patient-identifier-type");
export const SUBSCRIPTION_TAG_SYSTEM = codeSystemUrl("subscription-key");
export const TASK_STATUS_REASON_SYSTEM = codeSystemUrl("task-status-reason");
export const TREATMENT_CHOICE_CODE_SYSTEM = codeSystemUrl("treatment-observation-choice");
export const TREATMENT_PROCEDURE_KIND_SYSTEM = codeSystemUrl("procedure-kind");
export const VISIT_KIND_SYSTEM = codeSystemUrl("visit-kind");

export const CODE_SYSTEM_URLS: readonly CodeSystemUrl[] = [
  REGISTRATION_REVIEW_INPUT_SYSTEM,
  CASE_ACQUISITION_SYSTEM,
  AGGREGATE_WRITE_GUARD_SYSTEM,
  ACTIVITY_DEFINITION_CATALOG_SYSTEM,
  AI_DEVICE_TYPE_SYSTEM,
  AUDIT_EVENT_SUBTYPE_SYSTEM,
  COLLEAGUE_CALL_CATEGORY_SYSTEM,
  CONSULTATION_TYPE_SYSTEM,
  COUNTER_CODE_SYSTEM,
  CURATION_SESSION_SYSTEM,
  HS_PROTOCOL_TYPE_SYSTEM,
  LOCK_CODE_SYSTEM,
  MESSAGE_CHANNEL_SYSTEM,
  MINDFORGE_OBS_SYSTEM,
  NOTIFICATION_CATEGORY_SYSTEM,
  ORDER_KIND_SYSTEM,
  ORDER_SET_KIND_SYSTEM,
  OUTBOUND_MESSAGE_PURPOSE_SYSTEM,
  PLAN_DEFINITION_KIND_URL,
  PREFS_BASIC_SYSTEM,
  PROCEDURE_CODE_SYSTEM,
  RETRACTION_SYSTEM,
  SCHEDULE_SERVICE_TYPE_SYSTEM,
  SCHEDULING_PROFILE_TYPE_SYSTEM,
  SENTINEL_SERVICE_TYPE_SYSTEM,
  SOURCE_IDENTITY_TYPE,
  SUBSCRIPTION_TAG_SYSTEM,
  TASK_STATUS_REASON_SYSTEM,
  TREATMENT_CHOICE_CODE_SYSTEM,
  TREATMENT_PROCEDURE_KIND_SYSTEM,
  VISIT_KIND_SYSTEM,
];

export const DOCUMENT_AUDIENCE_SYSTEM = codeSystemUrl("document-audience");
